const modelName = "Vouchers";
const modelNameSingular = "Vouchers";
const endpoint = "/vouchers";

const setup = {
  title: modelName,
  singular: modelNameSingular,
  model: modelName.replace(/\s+/g, "-").toLowerCase(),
  canDelete: true,
  canAddNew: true,
  canSearch: true,
  endpoint,
  accessor: "id",
};

export default setup;
